/* eslint-disable jsdoc/check-param-names */
/* eslint-disable no-confusing-arrow */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@material-ui/core";
import { People, Person } from "@material-ui/icons";
import DealersDataGrid from "./data-grid/DealersDataGrid";

/**
 * Renders a table displaying dealer information, including their name, phone,
 * rank, and parent dealer details. Provides interactive buttons for viewing
 * dealer details and accessing downstream dealer data.
 *
 * @param {object[]} dealers - An array of dealer objects to be displayed.
 * @param {boolean} loading - Indicates if the data is still loading.
 * @returns {React.Element} A data grid component with dealer information and actions.
 */
export default function DealerDownstreamTable({ dealers, loading }) {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (dealers.downstream) {
      const fullDownStream = dealers.downstream.map(dealer => ({
        id: dealer.id,
        name: `${dealer.first_name} ${dealer.surname}`,
        phone: dealer.phone,
        parent_dealer: dealer.parent_id,
        is_leader: dealer.is_leader,
        is_admin: dealer.is_admin,
      }));

      setRows(fullDownStream);
    }
  }, [dealers]);

  const columns = [
    { field: "name", headerName: "Name", width: 200 },
    { field: "phone", headerName: "Phone", width: 120 },
    {
      field: "parent_dealer",
      headerName: "Parent",
      width: 180,
      renderCell: params => (
        <div className="d-flex justify-content-between align-items-center">
          Z-{params.row.parent_dealer}
        </div>
      ),
    },
    {
      field: "details",
      headerName: "Details",
      sortable: false,
      width: 120,
      renderCell: params => (
        <div
          className="d-flex justify-content-between align-items-center"
          style={{ cursor: "pointer" }}
        >
          <Link to={`/user-detail/${params.row.id}`}>
            <Button startIcon={<Person style={{ opacity: 0.5 }} />}>
              Details
            </Button>
          </Link>
        </div>
      ),
    },
    {
      field: "downstream",
      headerName: "Downstream",
      sortable: false,
      width: 140,
      renderCell: params =>
        !params.row.is_admin && !params.row.is_leader ? null : (
          <div
            className="d-flex justify-content-between align-items-center"
            style={{ cursor: "pointer" }}
          >
            <Link to={`/child-dealer-downstream/${params.row.id}`}>
              <Button startIcon={<People style={{ opacity: 0.5 }} />}>
                Downstream
              </Button>
            </Link>
          </div>
        ),
    },
  ];

  return (
    <DealersDataGrid rowsData={rows} columns={columns} loading={loading} />
  );
}
